{
  "id": "bragi",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Bragi",
    "en": "Bragi"
  },
  "icon": "gods/bragi",
  "portrait": "gods/bragi-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "battle-boar": 1
  },
  "unlocks": ["battle-boar", "long-serpent", "call-of-valhalla", "thurisaz-rune", "swine-array"],
  "powers": ["flaming-weapons"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Thor, Loki. Focus: myth units and earning Favor. Age tech HeroicAgeBragi."
  },
  "fieldMeta": {
    "freeUnitsOnAgeUp": {
      "source": "Game files 19.17020 (techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "HeroicAgeBragi: CreateUnit battle-boar quantity 1, generator AbstractTemple (spawns at a Temple)."
    }
  }
}
